import { render } from "./YoutubeIcon.vue?vue&type=template&id=0f37eb20"
import script from "./YoutubeIcon.vue?vue&type=script&lang=js"
export * from "./YoutubeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__